var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"name":"payment_method_tour","steps":_vm.tourSteps,"options":_vm.tourOptions,"callbacks":_vm.tourCallbacks}})
}
var staticRenderFns = []

export { render, staticRenderFns }